module.exports = __webpack_public_path__ + "img/cxTrends-16.8cd2aa7e.png";